import { Injectable, signal } from '@angular/core';

/** Dynamic header config a screen can patch in ngOnInit (title/subtitle/back),
 *  for the cases route `data` can't express statically (store/table name,
 *  payment-result's cart-vs-bill back target). Reset on every navigation. */
export interface HeaderDynamicConfig {
  title?: string | null;
  subtitle?: string | null;
  backAriaLabel?: string;
  /** Route commands relative to ['/t', token] for the header back button. */
  backHref?: string[] | null;
}

@Injectable({ providedIn: 'root' })
export class HeaderConfigService {
  readonly config = signal<HeaderDynamicConfig | null>(null);
  set(c: HeaderDynamicConfig): void { this.config.set(c); }
  clear(): void { this.config.set(null); }
}
